import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { UserService } from '@app/shared/services';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

@AutoUnsubscribe()
@Component({
  selector: 'contact-us-dialog',
  templateUrl: './contact-us-dialog.component.html',
  styleUrls: ['./contact-us-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactUsDialogComponent implements OnInit, OnDestroy {
  userId;
  contactUsForm: UntypedFormGroup;
  subscription = new Subscription();

  constructor(
    private dialogRef: MatDialogRef<ContactUsDialogComponent>,
    private _fb: UntypedFormBuilder,
    private userService: UserService,
    private toaster: ToastrService,
    private loginService: LoginStoreEffects
  ) {
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        if (state && state.data && state.data.id) {
          this.userId = state.data.id;
        }
      })
    );
  }

  ngOnInit(): void {
    this.contactUsForm = this._fb.group({
      message: ['', [Validators.required]],
    });
  }

  sendInquiry() {
    const payload = {
      user_id: this.userId,
      contact_type: 'Template Updates',
      msg: this.contactUsForm.controls['message'].value,
    };
    if (this.contactUsForm.valid) {
      this.subscription.add(
        this.userService.contactAdminCenter(payload).subscribe((res) => {
          this.toaster.success('Your request has been received');
          this.dialogRef.close();
        })
      );
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
